<template>
  <el-table
    border
    highlight-current-row
    tooltip-effect="dark"
    :data="data"
    :max-height="height"
  >
    <el-table-column header-align="center" label="时间" prop="date" width="160">
    </el-table-column>

    <el-table-column header-align="center" label="类别">
      <el-table-column
        show-overflow-tooltip
        align="center"
        min-width="30"
        v-for="col in cols"
        :key="col.key"
        :label="col.name"
      >
        <template slot-scope="prop">
          {{ formatNum(prop.row, col.key, col.unit) }}
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import { export_table_to_excel as exceljs } from '@/utlis/exportExcel'

export default {
  props: {
    cols: Array,
    data: Array,
    height: Number
  },
  data() {
    return {
      toFixed: true
    }
  },
  methods: {
    formatNum(row, key, unit) {
      let num = row[key]
      if (!+num) return num

      return `${Number(num).toFixed(1)}${unit}`
    },
    exportExcel(title) {
      exceljs(this.$el, title)
    }
  }
}
</script>

<style lang="css" scoped></style>
